import postal from "postal";

export const LINE_HOVER_POSTAL_TOPIC = "line.hover";
export const LINE_EDIT_SKETCH_DATA_POSTAL_TOPIC = "line.editSketchData";

const HIDE_DELAY_MS = 400;
let hideTimer = null;

const publish = (lineId) => postal.publish({ channel: "map", topic: LINE_HOVER_POSTAL_TOPIC, data: { lineId } });

export const showLineVertices = (lineId) => {
    clearTimeout(hideTimer);
    publish(lineId);
}

export const hideLineVertices = () => {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => publish(null), HIDE_DELAY_MS);
}
